var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hoc-mobile-hamburger hoc-mobile-hamburger-close",attrs:{"data-cy":_vm.$UI.Button.Mobile.Menu.Close},on:{"click":_vm.toggleMobileAside}},[_c('span'),_c('span'),_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }